import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./report-web-vitals";
import { CssBaseline } from "@mui/material";
import { AuthProvider } from "./contexts/auth-context";
import { LocalizationProvider as MuiDatePickerLocalizationProvider } from "@mui/x-date-pickers";
import AxiosInterceptor from "./api/axios-interceptors";
import { LocalizedThemeProvider } from "./theme";
import { UserProvider } from "./contexts/user-context";
import SuspenseFallback from "./components/suspense-fallback";
import { QueryClient, QueryClientProvider, } from '@tanstack/react-query'
import { I18nextProvider } from "./i18n.jsx";

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <I18nextProvider>
    <LocalizedThemeProvider>
      <React.Suspense fallback={<SuspenseFallback/>}>
        <QueryClientProvider client={queryClient}>
          <MuiDatePickerLocalizationProvider>
            <AuthProvider>
              <UserProvider>
                <AxiosInterceptor/>
                <CssBaseline/>
                <App/>
              </UserProvider>
            </AuthProvider>
          </MuiDatePickerLocalizationProvider>
        </QueryClientProvider>
      </React.Suspense>
    </LocalizedThemeProvider>
  </I18nextProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
